<template>
  <div>
    <div class="left_list">
      <div class="left_list_title left_list_title2">
        <span>顾客建议</span>
      </div>
      <ul class="advice" style="overflow: hidden; height: 304px">
        <VueSeamlessScroll
          :data="gkjyData"
          class="seamless-warp"
          :class-option="classOption"
        >
          <li v-for="(val, key) in gkjyData" :key="key" class="a_li">
            <div class="advice_rank" v-if="key < 10">0{{ key + 1 }}</div>
            <div class="advice_rank" v-else>{{ key + 1 }}</div>
            <div class="advice_txt">{{ val }}</div>
            <div class="advice_hot">
              <img src="@/assets/img/img_hot.png" />
            </div>
          </li>
        </VueSeamlessScroll>
      </ul>
    </div>
  </div>
</template>
<script>
import Swiper from "@/assets/js/swiper.min.js";
import * as echarts from "echarts";
import VueSeamlessScroll from "vue-seamless-scroll";
export default {
  props: {
    suggestions: {
      typeof: Array,
      default: () => [],
    },
  },
  data() {
    return {
      gkjyData: [
        "建议增加中山路的民俗活动",
        "建议增加中山路的民俗活动",
        "建议增加中山路的民俗活动",
        "建议增加中山路的民俗活动",
        "建议增加中山路的民俗活动",
      ],
    };
  },
  components: { VueSeamlessScroll },
  watch: {
    suggestions: {
      deep: true,
      handler: function (val) {
        this.getData();
      },
    },
  },
  mounted() {},

  created() {},
  computed: {
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 250, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  methods: {
    getData() {
      // console.log(this.suggestions)
      if (this.suggestions.length > 0) {
        this.gkjyData = [];
        for (let i = 0; i < this.suggestions.length; i++) {
          this.gkjyData.push(this.suggestions[i].content);
        }
      }
    },
  },
};
</script>
<style scoped src="@/assets/css/index3.css">
</style>
<style>
.a_li {
  width: 100%;
  height: 48px;
  background-color: rgba(2, 20, 57, 0.5);
  display: flex;
  padding-right: 28px;
  box-sizing: border-box;
  vertical-align: middle;
  align-items: center;
  margin-bottom: 16px;
}
</style>